<template>
  <div class="title"><i><slot></slot></i></div>
  <!-- <div class="title"><span></span> <i><slot></slot></i></div> -->
</template>

<script>
export default {
  name: "BsTitle",
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>


// WEBPACK FOOTER //
// src/components/en/packages/title/src/title.vue